// Other resource arrays
export interface ResourceLink {
  label: string;
  route: string;
}

export interface LearningResource {
  title: string;
  link: string;
  badge: string;
  color: string;
}
export const getMenteeResourcesLinks: ResourceLink[] = [
  { label: 'DASHBOARD.RESOURCES.MENTEE.RESOURCES_LINKS.CHEMISTRY_SESSION', route: '/chemistry' },
  { label: 'DASHBOARD.RESOURCES.MENTEE.RESOURCES_LINKS.QUESTIONS_TO_ASK', route: '/question-guide' },
  { label: 'DASHBOARD.RESOURCES.MENTEE.RESOURCES_LINKS.COMMUNICATING', route: '/communicating' },
  { label: 'DASHBOARD.RESOURCES.MENTEE.RESOURCES_LINKS.BUILDING_TRUST', route: '/trust' },
  { label: 'DASHBOARD.RESOURCES.MENTEE.RESOURCES_LINKS.BOOK_RECOMMENDATIONS', route: '/books' },
  { label: 'DASHBOARD.RESOURCES.MENTEE.RESOURCES_LINKS.WEBINARS_EVENTS', route: '/webinars' },
];

export const getMenteeOtherLinks: ResourceLink[] = [
  { label: 'DASHBOARD.RESOURCES.MENTEE.OTHER_LINKS.REFERRAL_PROGRAM', route: '/referral' },
  { label: 'DASHBOARD.RESOURCES.MENTEE.OTHER_LINKS.TUTORIAL', route: '/tutorial' },
];

export const getMentorResourcesLinks: ResourceLink[] = [
  { label: 'DASHBOARD.RESOURCES.MENTOR.RESOURCES_LINKS.STRUCTURE_SESSIONS', route: '/communicating' },
  { label: 'DASHBOARD.RESOURCES.MENTOR.RESOURCES_LINKS.CHEMISTRY_TIPS', route: '/chemistry' },
  { label: 'DASHBOARD.RESOURCES.MENTOR.RESOURCES_LINKS.CONVERSATION_QUESTIONS', route: '/question-guide' },
  { label: 'DASHBOARD.RESOURCES.MENTOR.RESOURCES_LINKS.SMART_GOALS', route: '/smartgoals-tips' },
  { label: 'DASHBOARD.RESOURCES.MENTOR.RESOURCES_LINKS.CHALLENGES', route: '/challenges' },
  { label: 'DASHBOARD.RESOURCES.MENTOR.RESOURCES_LINKS.BOOK_RECOMMENDATIONS', route: '/books' },
];

export const getMentorOtherLinks: ResourceLink[] = [
  { label: 'DASHBOARD.RESOURCES.MENTOR.OTHER_LINKS.WEBINARS_WORKSHOPS', route: '/webinars' },
  { label: 'DASHBOARD.RESOURCES.MENTOR.OTHER_LINKS.DISCOUNTS', route: '/discounts' },
  { label: 'DASHBOARD.RESOURCES.MENTOR.OTHER_LINKS.TUTORIAL', route: '/tutorial' },
];

export const getLearningResources = (translateFn: (key: string) => string): LearningResource[] => [
  {
    title: translateFn('DASHBOARD.RESOURCES.LEARNING_RESOURCES.CAREER_PIVOTING'),
    link: 'https://www.femmepalette.com/resources/career-pivoting-guide',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.E_BOOK'),
    color: 'blue',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.LEARNING_RESOURCES.INCLUSIVE_LANGUAGE'),
    link: 'https://www.femmepalette.com/resources/inclusive-language-guide',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.E_BOOK'),
    color: 'blue',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.LEARNING_RESOURCES.NEGOTIATION'),
    link: 'https://www.femmepalette.com/resources/negotiation-guide',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.E_BOOK'),
    color: 'blue',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.LEARNING_RESOURCES.EMPOWERING_WOMEN'),
    link: '/empowering',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.RESOURCE'),
    color: 'orange',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.LEARNING_RESOURCES.PRODUCTIVITY'),
    link: 'https://www.femmepalette.com/resources/productivity-course',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.EMAIL_COURSE'),
    color: 'green',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.LEARNING_RESOURCES.MOTHERHOOD_CAREER'),
    link: 'https://www.femmepalette.com/resources/motherhood-career-guide',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.E_BOOK'),
    color: 'blue',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.LEARNING_RESOURCES.WORKPLACE_GAME'),
    link: 'https://www.femmepalette.com/resources/how-to-play-the-workplace-game',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.E_BOOK'),
    color: 'blue',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.LEARNING_RESOURCES.PERSONAL_DEVELOPMENT'),
    link: 'https://www.femmepalette.com/resources/personal-development-template',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.E_BOOK'),
    color: 'blue',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.LEARNING_RESOURCES.LEADERSHIP'),
    link: 'https://www.femmepalette.com/resources/guide-to-leadership',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.E_BOOK'),
    color: 'blue',
  },
];

export const getMenteeLearningResources = (translateFn: (key: string) => string): LearningResource[] => [
  {
    title: translateFn('DASHBOARD.RESOURCES.MENTEE.LEARNING_RESOURCES.IMPOSTER_SYNDROME'),
    link: 'https://www.femmepalette.com/resources/imposter-syndrome',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.E_BOOK'),
    color: 'blue',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.MENTEE.LEARNING_RESOURCES.WELLBEING'),
    link: 'https://www.femmepalette.com/resources/wellbeing-course',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.EMAIL_COURSE'),
    color: 'green',
  },
];

export const getMentorLearningResources = (translateFn: (key: string) => string): LearningResource[] => [
  {
    title: translateFn('DASHBOARD.RESOURCES.MENTOR.LEARNING_RESOURCES.MENTORING_TIPS'),
    link: '/tips',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.RESOURCE'),
    color: 'orange',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.MENTOR.LEARNING_RESOURCES.IMPOSTER_SYNDROME'),
    link: 'https://www.femmepalette.com/resources/imposter-syndrome',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.E_BOOK'),
    color: 'blue',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.MENTOR.LEARNING_RESOURCES.CASE_STUDIES'),
    link: '/case-studies',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.RESOURCE'),
    color: 'orange',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.MENTOR.LEARNING_RESOURCES.WELLBEING'),
    link: 'https://www.femmepalette.com/resources/wellbeing-course',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.EMAIL_COURSE'),
    color: 'green',
  },
  {
    title: translateFn('DASHBOARD.RESOURCES.MENTOR.LEARNING_RESOURCES.ALL_RESOURCES'),
    link: '/all-resources',
    badge: translateFn('DASHBOARD.RESOURCES.BADGES.RESOURCE'),
    color: 'orange',
  },
];
export const getNetworkingResourcesLinks: ResourceLink[] = [
  { label: 'DASHBOARD.NETWORKING.RESOURCES_LINKS.ONE_ON_ONE_NETWORK', route: '/one_on_one_networking' },
  { label: 'DASHBOARD.NETWORKING.RESOURCES_LINKS.NETWORK_ICE_BREAKERS', route: '/networking_ice_breakers' },
  { label: 'DASHBOARD.NETWORKING.RESOURCES_LINKS.ONLINE_NETWORK', route: '/tips_for_online_networking' },
  { label: 'DASHBOARD.NETWORKING.RESOURCES_LINKS.NETWORK_INTROVERTS', route: '/networking_for_introverts' },
];
